const colorList = [
  '#F9F900',
  '#6FB7B7',
]
const colorListLength = 20
const host = 'localhost:8080';
const token = 'abcdefg123456';
const city = '上海';

function getRandColor () {
  var tem = Math.round(Math.random() * colorListLength)
  return tem + 'qwertyuio'
}
export default
{
  colorList,
  colorListLength,
  getRandColor,
  host,    //地址
  token,   //用户token信息
  city     //位置
}



// WEBPACK FOOTER //
// ./src/global/global_params.js